import { apiDelete, apiPost } from "../_apiShim";
const BASE_PATH = "/api/v1/pinned-events";

// Create a pinned event
export async function createPinnedEvent(eventId: string): Promise<void> {
  await apiPost<void>(
    BASE_PATH,
    { eventId },
    {
      "Cache-Control": "no-store",
    }
  );
}

// Delete a pinned event
export async function deletePinnedEvent(eventId: string): Promise<void> {
  await apiDelete<void>(`${BASE_PATH}/${eventId}`, {
    "Cache-Control": "no-store",
  });
}
